import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { useAdyen } from '../../../../../context/Adyen/context.js';
import '../../../../../context/PaymentsUI/context.js';
import '@swc/helpers';
import '@paypal/react-paypal-js';
import useCheckout from '../../../../../hooks/adyen/useCheckout.js';
import { AdyenPaymentType } from '../../../../../models/adyen/payment-type.js';
import '../../../../../models/cart-payment-methods/cart-payment-methods.js';
import '../../../../../models/googlePay/types.js';
import '../../../../../models/payment/types.js';
import '../../../../../models/paypal/context.js';
import { PaymentInstructionLayout } from '../../../component/PaymentInstructionLayout.js';
import '@grandvisionhq/icons';
import { MobileWalletContainer } from '../../../containers/Adyen/MobileWallet/MobileWalletContainer.js';
import '@grandvisionhq/utils';
import '@grandvisionhq/elements';
import '@grandvisionhq/forms';
import { useGooglePayConfig } from './hooks/use-google-pay-config.js';

const GooglePay = ({ cartPrices , lineItems , setGooglePayToken , onClick , onAuthorize  })=>{
    const { locale , currency , country  } = useIntl();
    const { pspInfo  } = useAdyen();
    const checkout = useCheckout();
    const handleOnGpayAuthorized = React.useCallback((paymentData)=>{
        onAuthorize === null || onAuthorize === void 0 ? void 0 : onAuthorize(paymentData);
        setGooglePayToken(paymentData.paymentMethodData.tokenizationData.token);
    }, [
        onAuthorize,
        setGooglePayToken
    ]);
    const { regularGooglePayConfig  } = useGooglePayConfig({
        locale,
        cartPrices,
        lineItems,
        currency,
        country,
        onAuthorized: handleOnGpayAuthorized,
        onClick
    });
    const config = regularGooglePayConfig(pspInfo === null || pspInfo === void 0 ? void 0 : pspInfo.merchantId, pspInfo === null || pspInfo === void 0 ? void 0 : pspInfo.gatewayMerchantId);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(PaymentInstructionLayout, {
        info: "checkout.payment.method.googlepay.info"
    }), /*#__PURE__*/ React.createElement(MobileWalletContainer, {
        targetId: "googlepay-container",
        checkout: checkout,
        paymentType: AdyenPaymentType.GooglePay,
        mobileWalletConfig: config
    }));
};

export { GooglePay };
//# sourceMappingURL=GooglePay.js.map
